import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { FreigabeService } from './freigabe.service';

export const freigabeGuard: CanActivateChildFn = (_route, state) => {
  const freigabe = inject(FreigabeService);
  const router = inject(Router);
  return freigabe.erlaubt(state.url) ? true : router.createUrlTree(['/']);
};
